import { Injectable } from '@angular/core';
import { SortOption } from 'src/app/modules/shared/pipes/sort.pipe';
import { BaseRepository } from './abstract/base.repository';

export interface Country {
    id: string;
    name: string;
  }

export const countriesSortOptions: SortOption[] = [
  { label: $localize `:Sort label Name:Name`, property: 'name' }  
];

@Injectable({ providedIn: 'root' })
export class CountriesRepository extends BaseRepository<Country> {

  constructor() {
    super('countries', countriesSortOptions);
  }

}